const STORAGE_KEY = 'xiaoying.vnext.prototype.saved-official-assets';
const CHANGE_EVENT = 'xiaoying:vnext-preview-assets';

export function readPreviewAddedAssets() {
  if (typeof window === 'undefined') return [];
  try {
    const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(value) ? value.filter(asset => asset?.id && asset?.official_asset_id) : [];
  } catch {
    return [];
  }
}

function writePreviewAddedAssets(assets) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(assets));
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT));
}

export function savePreviewOfficialAsset(asset) {
  const current = readPreviewAddedAssets();
  const existing = current.find(item => item.official_asset_id === asset.id);
  if (existing) return existing;
  const saved = {
    ...asset,
    id: `saved-${asset.id}`,
    source: 'official_reference',
    official_asset_id: asset.id,
    updated_at: new Date().toISOString(),
  };
  writePreviewAddedAssets([saved, ...current]);
  return saved;
}

export function removePreviewAddedAssets(ids) {
  const targets = new Set(ids);
  writePreviewAddedAssets(readPreviewAddedAssets().filter(asset => !targets.has(asset.id)));
}

export function subscribePreviewAddedAssets(listener) {
  if (typeof window === 'undefined') return () => {};
  const handleChange = () => listener(readPreviewAddedAssets());
  window.addEventListener(CHANGE_EVENT, handleChange);
  window.addEventListener('storage', handleChange);
  return () => {
    window.removeEventListener(CHANGE_EVENT, handleChange);
    window.removeEventListener('storage', handleChange);
  };
}
